module.exports = __webpack_public_path__ + "img/IMAGE 6.765a60b4.png";